import React from 'react';

function ShareIcon({ width, height, fill }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height}>
      <path
        d='M16.554 14.723a2.631 2.631 0 0 0-1.771.7L8.34 11.669a2.958 2.958 0 0 0 .081-.633 2.958 2.958 0 0 0-.081-.636l6.37-3.714a2.7 2.7 0 1 0-.867-1.979 2.958 2.958 0 0 0 .081.633l-6.37 3.717a2.711 2.711 0 1 0 0 3.958l6.434 3.759a2.549 2.549 0 0 0-.072.587 2.639 2.639 0 1 0 2.639-2.639Z'
        data-name='Path 2226'
        fill={fill}
        transform='translate(-3 -2)'
      />
    </svg>
  );
}

ShareIcon.defaultProps = {
  width: 16,
  height: 18,
  fill: '#43425d'
};

export default ShareIcon;
